import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, Fab, Stack } from '@mui/material';
import ScrollToTop from '../components/Common/ScrollToTop';
import Footer from '../components/Footer/Footer';
import Navbar from '../components/Navbar/Navbar';
import Sidebar from '../components/Sidebar/Sidebar';
import { companyInfo, contactQuickInfo, footerRanges, navLinks, pageActions, sidebarLinks } from '../data/siteData';

function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <ScrollToTop />
      <Navbar
        navLinks={navLinks}
        companyInfo={companyInfo}
        onMenuClick={() => setSidebarOpen((prev) => !prev)}
      />
      <Sidebar
        companyInfo={companyInfo}
        sidebarLinks={sidebarLinks}
        quickInfo={contactQuickInfo}
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        whatsappPath={pageActions.whatsappPath}
      />
      <Box sx={{ display: 'flex' }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minHeight: '100vh',
            pt: '64px',
          }}
        >
          <Outlet />
          <Footer companyInfo={companyInfo} navLinks={navLinks} footerRanges={footerRanges} />
        </Box>
      </Box>

      <Stack spacing={1.5} sx={{ position: 'fixed', right: 20, bottom: 20, zIndex: 1400 }}>
        <Fab component="a" href={pageActions.whatsappPath} target="_blank" rel="noreferrer" sx={{ bgcolor: '#25d366', color: '#ffffff', '&:hover': { bgcolor: '#1fb95a' } }}>
          <WhatsAppIcon />
        </Fab>
        <Fab component="a" href={pageActions.callPath} sx={{ bgcolor: '#c9a84c', color: '#1a0533', '&:hover': { bgcolor: '#d3b45d' } }}>
          <CallRoundedIcon />
        </Fab>
      </Stack>
    </>
  );
}

export default MainLayout;
